import React from 'react';
import okGreen from "../../../../../assets/images/ok-green.svg"
import './payment-plan-table.scss';

interface PaymentPlanTableProps {
}

const PaymentPlanTable: React.FC<PaymentPlanTableProps> = () => {
    return (
        <div className="payment-plan-table">
            <table>
                <tr>
                    <td style={{ paddingTop: '30px' }}>
                        <h2>Credits PAYG<br /> vs Package Deals</h2>
                    </td>
                    <td>
                        <b>Credits PAYG</b>
                        <em>Buy credits as needed at the standard individual credit price.</em>
                    </td>
                    <td>
                        <b>
                            Package Deals
                            <div>Recommended</div>
                        </b>
                        <em>Get 5, 10, 30 or 80 credits at the special discounted price. </em>
                    </td>
                </tr>
                <tr>
                    <td className={"payment-plan-table__label"}>Individual Credit Price</td>
                    <td>$200/credit</td>
                    <td>$185/credit (lower your cost!)</td>
                </tr>
                <tr>
                    <td className={"payment-plan-table__label"}>Credit Expiration</td>
                    <td>1 month</td>
                    <td>Matches contract period</td>
                </tr>
                <tr>
                    <td className={"payment-plan-table__label"}>Contract Period </td>
                    <td>NA</td>
                    <td>1 month, 3 months, 12 months</td>
                </tr>
                <tr>
                    <td className={"payment-plan-table__label"}>Submit New Tasks with Credits</td>
                    <td>
                        <div className={"payment-plan-table__icon"}>
                            <img src={okGreen} alt=""/> Yes
                        </div>
                    </td>
                    <td>
                        <div className={"payment-plan-table__icon"}>
                            <img src={okGreen} alt=""/> Yes
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className={"payment-plan-table__label"}>Receive Updates on Activated Tasks</td>
                    <td>
                        <div className={"payment-plan-table__icon"}>
                            <img src={okGreen} alt=""/> Yes
                        </div>
                    </td>
                    <td>
                        <div className={"payment-plan-table__icon"}>
                            <img src={okGreen} alt=""/> Yes
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className={"payment-plan-table__label"}>Book Calls with Credits</td>
                    <td>
                        <div className={"payment-plan-table__icon"}>
                            <img src={okGreen} alt=""/> Yes
                        </div>
                    </td>
                    <td>
                        <div className={"payment-plan-table__icon"}>
                            <img src={okGreen} alt=""/> Yes
                        </div>
                    </td>
                </tr>
                <tr>
                    <td className={"payment-plan-table__label"}>Access Past Conversations, Documents<br /> & Follow-ups</td>
                    <td>
                        <div className={"payment-plan-table__icon"}>
                            <img src={okGreen} alt=""/> Yes
                        </div>
                    </td>
                    <td>
                        <div className={"payment-plan-table__icon"}>
                            <img src={okGreen} alt=""/> Yes
                        </div>
                    </td>
                </tr>
            </table>
        </div>
    );
};

export default PaymentPlanTable;